/**
 * Tavus `internet_search` skill: lets the pal ground answers in live web
 * results. It takes no configuration and has no document dependency, so it is
 * a pure attach/detach on the pal — which means the editor can always show the
 * *actual* state instead of a stored intent that may have drifted.
 */
import { tavus } from "./client";

export const TAVUS_INTERNET_SEARCH_SKILL_ID = "internet_search";

/** Actual attachment state on the pal. Tavus owns this value. */
export async function getInternetSearchSkillState(palId: string): Promise<boolean> {
  const res = await tavus.getPalSkill({
    pal_id: palId,
    skill_id: TAVUS_INTERNET_SEARCH_SKILL_ID,
  });
  return !!res.attached;
}

/**
 * Converge the pal toward `enabled` and return the state Tavus reports
 * afterwards, so callers persist confirmed truth rather than intent.
 */
export async function syncInternetSearchSkill(input: {
  palId: string;
  enabled: boolean;
}): Promise<boolean> {
  if (input.enabled) {
    await tavus.attachSkill({
      pal_id: input.palId,
      skill_id: TAVUS_INTERNET_SEARCH_SKILL_ID,
      config: {},
    });
  } else {
    await tavus.detachSkill({
      pal_id: input.palId,
      skill_id: TAVUS_INTERNET_SEARCH_SKILL_ID,
    });
  }
  return getInternetSearchSkillState(input.palId);
}